function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "12.193%",
  x2: "100%",
  y2: "87.807%",
  id: "CompanySegment_svg__22_a"
}, React.createElement("stop", {
  stopColor: "#4DB1FD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#148CFC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.385 17c.977 0 1.769.814 1.769 1.818v3.637h-1.77c-.977 0-1.769.814-1.769 1.818v9.09h-2.653a.897.897 0 00-.885.91V37h-6.192a.897.897 0 01-.885-.91V25.693c0-.834.553-1.561 1.34-1.764l3.968-1.019v-4.09c0-1.005.792-1.819 1.769-1.819h5.308zm9.288 16.364c.733 0 1.327.594 1.327 1.327v.982c0 .733-.594 1.327-1.327 1.327h-7.961a1.327 1.327 0 01-1.327-1.327v-.982c0-.733.594-1.327 1.327-1.327h7.961zm-18.577 0h-.884a.449.449 0 00-.443.454v.91c0 .25.198.454.443.454h.884a.449.449 0 00.442-.455v-.909a.449.449 0 00-.442-.454zm16.808.909h-5.308a.442.442 0 00-.435.363l-.007.079v.025c0 .217.156.397.363.435l.08.007h5.307a.442.442 0 00.435-.363l.007-.08v-.024a.442.442 0 00-.442-.442zm-11.5-4.546h-.885a.449.449 0 00-.442.455v.909c0 .25.198.454.442.454h.885a.449.449 0 00.442-.454v-.91a.449.449 0 00-.442-.454zm-5.308 0h-.884a.449.449 0 00-.443.455v.909c0 .25.198.454.443.454h.884a.449.449 0 00.442-.454v-.91a.449.449 0 00-.442-.454zm18.577-5.454c.733 0 1.327.594 1.327 1.327v4.619c0 .732-.594 1.326-1.327 1.326h-7.961a1.327 1.327 0 01-1.327-1.326v-4.62c0-.732.594-1.326 1.327-1.326h7.961zm-3.538 3.636h-3.539a.442.442 0 00-.435.363l-.007.08v.024c0 .217.156.398.363.435l.08.007h3.538a.442.442 0 00.435-.363l.007-.08v-.024a.442.442 0 00-.442-.442zm-9.731-1.818h-.885a.449.449 0 00-.442.454v.91c0 .25.198.454.442.454h.885a.449.449 0 00.442-.454v-.91a.449.449 0 00-.442-.454zm-5.308 0h-.884a.449.449 0 00-.443.454v.91c0 .25.198.454.443.454h.884a.449.449 0 00.442-.454v-.91a.449.449 0 00-.442-.454zm17.692 0h-6.192a.442.442 0 00-.435.363l-.007.08v.024c0 .217.156.397.363.435l.08.007h6.191a.442.442 0 00.436-.363l.007-.08v-.024a.442.442 0 00-.443-.442zm-12.384-3.636h-.885a.449.449 0 00-.442.454v.91c0 .25.198.454.442.454h.885a.449.449 0 00.442-.455v-.909a.449.449 0 00-.442-.454zm0-3.637h-.885a.449.449 0 00-.442.455v.909c0 .25.198.454.442.454h.885a.449.449 0 00.442-.454v-.91a.449.449 0 00-.442-.454zm3.538 0h-.884a.449.449 0 00-.443.455v.909c0 .25.198.454.443.454h.884a.449.449 0 00.443-.454v-.91a.449.449 0 00-.443-.454z",
  transform: "translate(-44 -17)",
  fill: "url(#CompanySegment_svg__22_a)",
  fillRule: "evenodd"
});

var SvgCompanySegment = function SvgCompanySegment(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20"
  }, props), _ref, _ref2);
};

export default SvgCompanySegment;